export default __webpack_public_path__ + "static/media/edge-logo.bff5d84e.svg";